import * as React from "react";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { Circle } from "lucide-react";
import { cn } from "@/lib/utils";

export interface ShadcnRadioProps
  extends React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> {
  label?: string;
  description?: string;
}

const ShadcnRadio = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  ShadcnRadioProps
>(({ className, label, description, ...props }, ref) => {
  return (
    <div className="flex items-start gap-3">
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          "aspect-square h-4 w-4 rounded-full border border-[#EDC29C]/40 bg-[#161616] text-[#EDC29C] ring-offset-[#161616] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#EDC29C] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-[#EDC29C] mt-[-0.9px]",
          className
        )}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
          <Circle className="h-2.5 w-2.5 fill-current text-current" />
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
      {(label || description) && (
        <div className="flex flex-col gap-1">
          {label && (
            <label
              htmlFor={props.id}
              className="text-sm font-medium text-white leading-none cursor-pointer"
            >
              {label}
            </label>
          )}
          {description && (
            <p className="text-xs text-white/60 leading-relaxed">
              {description}
            </p>
          )}
        </div>
      )}
    </div>
  );
});
ShadcnRadio.displayName = "ShadcnRadio";

export { ShadcnRadio };
